import type { SvgProps } from '@/types/svgs/svg-types';

const SiteWideJackpotToggleOn = ({ lineColor }: SvgProps) => (
    <svg width="26" height="17" viewBox="0 0 26 17" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect
            x="0.75"
            y="-0.75"
            width="23.52"
            height="15.4"
            rx="7.7"
            transform="matrix(1 0 0 -1 0 15.4004)"
            stroke="url(#paint0_linear_10538_81409)"
            strokeWidth="1.5"
        />
        <path
            d="M16.5704 3.41023C13.7868 3.41023 11.5304 5.66672 11.5304 8.45023C11.5304 11.2337 13.7868 13.4902 16.5704 13.4902C19.3539 13.4902 21.6104 11.2337 21.6104 8.45023C21.6104 5.66672 19.3539 3.41023 16.5704 3.41023Z"
            fill="url(#paint1_linear_10538_81409)"
        />
        <defs>
            <linearGradient
                id="paint0_linear_10538_81409"
                x1="-5.35613"
                y1="1.20625e-07"
                x2="20.3119"
                y2="26.6085"
                gradientUnits="userSpaceOnUse">
                <stop stopColor={lineColor ?? '#61019B'} />
                <stop offset="1" stopColor={lineColor ?? '#005FC8'} />
            </linearGradient>
            <linearGradient
                id="paint1_linear_10538_81409"
                x1="23.7682"
                y1="13.4902"
                x2="9.37249"
                y2="3.41023"
                gradientUnits="userSpaceOnUse">
                <stop stopColor={lineColor ?? '#61019B'} />
                <stop offset="1" stopColor={lineColor ?? '#005FC8'} />
            </linearGradient>
        </defs>
    </svg>
);

export default SiteWideJackpotToggleOn;
